export default "__VITE_ASSET__DKvWrEYi__"